import React, { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListOl } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import SoftBadge from 'components/common/SoftBadge';
import masterCardImg from 'assets/img/illustrations/mastercard.png';
import visaImg from 'assets/img/illustrations/visaIcon.jpg';

const PagoItem = ({
    pago,
    idCatTipoUsuario,
    onEdit,
    onValidar,
    onConciliar,
    onFacturar,
    onFacturarIngreso,
    orden
}) => {
    const p = pago;

    // Medio de pago actual (el que se puede cambiar: idCatMedioPago 2 = STRIPE, 3 = PAYPAL, 5 = EFECTIVO)
    const medioPagoActual = (
        p.idCatMedioPago === 2 ? 'STRIPE' :
        p.idCatMedioPago === 3 ? 'PAYPAL' :
        p.idCatMedioPago === 5 ? 'EFECTIVO' :
        p.idCatMedioPago === 1 ? 'BANCO' :
        p.idCatMedioPago === 4 ? 'WESTERN UNION' :
        (p.vMedioPago ? p.vMedioPago.toUpperCase() :
        (p.vSistemaPago ? p.vSistemaPago.toUpperCase() : 'STRIPE'))
    );

    const badgeMedioPagoBg = medioPagoActual.includes('PAYPAL')
        ? 'paypal'
        : medioPagoActual.includes('STRIPE')
            ? 'stripe'
            : 'primary';

    // Sistema de pago original (el inmutable que no se puede modificar)
    const sistemaPagoOriginal = (
        p.vSistemaPago ||
        (p.vReferencia && (p.vReferencia.startsWith('PAYID') || p.vReferencia.startsWith('PAYPAL')) ? 'PAYPAL' : '') ||
        (p.vReferencia && (p.vReferencia.startsWith('pi_') || p.vReferencia.startsWith('ch_') || p.vReferencia.startsWith('in_') || p.vReferencia.startsWith('cs_')) ? 'STRIPE' : '') ||
        'MANUAL'
    )?.toUpperCase();

    const badgeSistemaPagoOriginalBg = sistemaPagoOriginal.toLowerCase().includes('paypal')
        ? 'paypal'
        : sistemaPagoOriginal.toLowerCase().includes('stripe')
            ? 'stripe'
            : 'secondary';

    return (
        <div>
            <Row className="fs--1 align-items-center">
                <Col xs={12} md={6}>
                    {!p.vUUIDLinkPago && p.idCatCuentaBancaria == 0 && (
                        <Link to={""} onClick={onEdit}>
                            <img src="/img/editar20.png" alt="Editar"></img>
                        </Link>
                    )}
                    <div className="d-flex align-items-center gap-2 mb-2">
                        <strong>Pago #
                            {idCatTipoUsuario == 1 ? (
                                <Link onClick={() => onConciliar(p.idPago)}>{p.idPago}</Link>
                            ) : (
                                <span>{p.idPago}</span>
                            )}
                        </strong>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <FontAwesomeIcon icon="calendar-alt" className="text-primary" />
                        <span className="fw-semibold">{p.dFechaPagoLarga}</span>
                    </div>
                </Col>
                <Col xs={12} md={6} className="text-md-end mt-2 mt-md-0">
                    <div className="mb-2">
                        <h5 className="mb-0 text-primary">
                            ${parseFloat(p.dImportePago).toLocaleString("es-MX", {
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2
                            })} {p.vMoneda}
                        </h5>
                        <small className="text-muted">Importe del pago</small>
                        {p.dTipoCambio > 1 && (
                            <div className="mt-1">
                                <small className="text-muted">
                                    <FontAwesomeIcon icon="exchange-alt" className="me-1" />
                                    T.C. <strong>{parseFloat(p.dTipoCambio).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 4 })}</strong>
                                </small>
                            </div>
                        )}
                    </div>
                </Col>
            </Row>

            {p.iNumeroParcialidad > 0 && orden.vClave && orden.vClave.includes('99') && (
                <div className="text-center my-2">
                    <span className="badge bg-primary fs-0 px-3 py-2">
                        <FontAwesomeIcon icon={faListOl} className="me-2" />
                        Parcialidad {p.iNumeroParcialidad}
                    </span>
                </div>
            )}

            {/* Información de saldos para ordenes a credito */}
            {orden.vClave === '99' && (p.dSaldoAnterior >= 0 || p.dSaldoInsoluto >= 0) && (
                <div className="my-2 p-2 bg-light rounded">
                    <Row className="fs--1">
                        {p.dSaldoAnterior >= 0 && (
                            <Col xs={12} sm={4} className="mb-1 mb-sm-0">
                                <div className="text-center">
                                    <div className="text-muted small">Saldo Anterior</div>
                                    <div className="fw-bold">
                                        ${parseFloat(p.dSaldoAnterior).toLocaleString("es-MX", {
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits: 2
                                        })}
                                    </div>
                                </div>
                            </Col>
                        )}
                        <Col xs={12} sm={4} className="mb-1 mb-sm-0">
                            <div className="text-center">
                                <div className="text-muted small">Importe Pagado</div>
                                <div className="fw-bold text-success">
                                    ${parseFloat(p.dImportePago).toLocaleString("es-MX", {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    })}
                                </div>
                            </div>
                        </Col>
                        {p.dSaldoInsoluto >= 0 && (
                            <Col xs={12} sm={4}>
                                <div className="text-center">
                                    <div className="text-muted small">Saldo Insoluto</div>
                                    <div className="fw-bold text-danger">
                                        ${parseFloat(p.dSaldoInsoluto).toLocaleString("es-MX", {
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits: 2
                                        })}
                                    </div>
                                </div>
                            </Col>
                        )}
                    </Row>
                </div>
            )}

            <div className="mb-0 fs--1">
                {p.vReferencia ? (
                    <>REF. {p.vReferencia}</>
                ) : (
                    <SoftBadge pill bg={'danger'} className="fs--2">
                        <span className="mt-1 mb-1">No hay referencias</span>
                        <FontAwesomeIcon
                            icon={classNames({
                                check: p.vReferencia,
                                stream: !p.vReferencia
                            })}
                            transform="shrink-2"
                            className="ms-1 auto"
                        />
                    </SoftBadge>
                )}
            </div>

            {p.vComprobante && !p.vUUIDLinkPago && (
                <p className="mb-0 fs--1">
                    {p.vComprobante.includes('.pdf') && <img src="/img/pdf20.png" alt="PDF"></img>}
                    {!p.vComprobante.includes('.pdf') && <img src="/img/imagen20.png" alt="Imagen"></img>}
                    &nbsp;
                    <a className="stretched-link text-info position-relative" href={"/api/orden/onget/?name=" + p.vComprobante} target="_blank" rel="noreferrer">
                        {p.vComprobante}
                    </a>
                </p>
            )}

            {(p.vUUIDLinkPago || p.vReciboLink) && (
                <div>
                    {p.vUUIDLinkPago && (
                        <span className="mt-2 fs--1 fw-bold me-2">Pago del link #{p.idLinkPago}</span>
                    )}
                    {p.vReciboLink && (
                        <Link className="stretched-link text-info position-relative fs--1" to={p.vReciboLink} target="_blank">
                            Recibo
                        </Link>
                    )}
                    <SoftBadge pill bg={badgeMedioPagoBg} className="fs--2 ms-1">
                        <span className="mt-1 mb-1">{medioPagoActual}</span>
                    </SoftBadge>
                </div>
            )}

            {p.vDescripcionFormaPago && (
                <Row className="fs--1">
                    <Col className="col-12">
                        <span className="me-1">{p.vClave + " " + p.vDescripcionFormaPago}</span>
                        {p.vJsonDetallesLinkPago && p.vJsonDetallesLinkPago != "undefined" &&
                            JSON.parse(p.vJsonDetallesLinkPago).vCardCompany == "visa" && (
                                <img src={visaImg} width={45} alt="Visa" className="" />
                            )}
                        {p.vJsonDetallesLinkPago && p.vJsonDetallesLinkPago != "undefined" &&
                            JSON.parse(p.vJsonDetallesLinkPago).vCardCompany == "mastercard" && (
                                <img src={masterCardImg} width={30} alt="MasterCard" className="" />
                            )}
                    </Col>
                </Row>
            )}

            {p.idCatCuentaBancaria > 0 && (
                <p className="mb-0 fs--1">
                    {p.vMedioPago} - {p.vNumCta}- {p.vAlias} &nbsp;&nbsp;&nbsp;
                    {p.dTipoCambio > 1 && <span>T. C.: {p.dTipoCambio}</span>}
                </p>
            )}

            {sistemaPagoOriginal && (
                <p className="mb-1 fs--2 text-muted">
                    Sistema de Pago Original: <SoftBadge pill bg={badgeSistemaPagoOriginalBg} className="fs--2 ms-1">{sistemaPagoOriginal}</SoftBadge>
                </p>
            )}

            {p.vNombreVendedor && <p className="mb-0 fs--2">REGISTRADO POR: {p.vNombreVendedor}</p>}
            {p.dCreatedDate && <p className="mb-0 fs--2">Fecha Registro: {p.dCreatedDate}</p>}

            <Row>
                <Col className="mt-1">
                    <SoftBadge pill bg={p.bIsPagado > 0 ? 'success' : 'danger'} className="fs--2">
                        <span className="mb-0">
                            {p.bIsPagado == 1 && 'Pagado'}
                            {p.bIsPagado == 0 && 'No pagado'}
                        </span>
                        <FontAwesomeIcon
                            icon={classNames({
                                check: p.idCatCuentaBancaria > 0,
                                stream: p.idCatCuentaBancaria == 0
                            })}
                            transform="shrink-2"
                            className="ms-1 auto"
                        />
                    </SoftBadge>&nbsp;
                    {p.bIsPagado == 1 && (
                        <>
                            <SoftBadge pill bg={p.idCatCuentaBancaria > 0 ? 'success' : 'warning'} className="fs--2">
                                <span className="mb-0">
                                    {p.idCatCuentaBancaria > 0 && 'Validado'}
                                    {p.idCatCuentaBancaria == 0 && 'No validado'}
                                </span>
                                <FontAwesomeIcon
                                    icon={classNames({
                                        check: p.idCatCuentaBancaria > 0,
                                        stream: p.idCatCuentaBancaria == 0
                                    })}
                                    transform="shrink-2"
                                    className="ms-1 auto"
                                />
                            </SoftBadge>&nbsp;
                            <SoftBadge pill bg={p.bIsFacturado ? 'success' : 'warning'} className="fs--2">
                                <span className="mb-0">
                                    {p.bIsFacturado && 'Facturado'}
                                    {!p.bIsFacturado && <a href="#">No facturado</a>}
                                </span>
                                <FontAwesomeIcon
                                    icon={classNames({
                                        check: p.bIsFacturado,
                                        stream: !p.bIsFacturado
                                    })}
                                    transform="shrink-2"
                                    className="ms-1 auto"
                                />
                            </SoftBadge>
                        </>
                    )}
                </Col>
            </Row>
            {p.idFacturaPagoEmitido > 0 &&
                <Row>
                    <Col>
                        <Link to={`/contabilidad/centro-xml/pagos-emitidos/visualizacion/${p.idFacturaPagoEmitido}`}>
                            <Button size="sm" variant="falcon-info" className="fs--2 mt-2">
                                Ver complemento de pago
                            </Button>
                        </Link>
                    </Col>
                </Row>
            }
            {idCatTipoUsuario == "1" && p.idCatCuentaBancaria == 0 && (
                <>
                    <hr></hr>
                    <Row>
                        <Col>&nbsp;</Col>
                        <Col md="auto" className="mt-1">
                            {p.bIsPagado == 1 && (
                                <Button
                                    size="sm"
                                    className="fs--2 me-2"
                                    onClick={onValidar}
                                    variant="falcon-success"
                                >
                                    Validar pago
                                </Button>
                            )}
                        </Col>
                    </Row>
                </>
            )}

            {!p.bIsFacturado && p.idCatCuentaBancaria > 0 && orden.vClave === '99' && (
                <>
                    <hr></hr>
                    <Row>
                        <Col>&nbsp;</Col>
                        <Col md="auto" className="mt-1 d-flex align-items-center">
                            <Button
                                size="sm"
                                className="fs--2 me-2"
                                onClick={() => onFacturar(p.idPago)}
                                variant="falcon-primary"
                            >
                                Facturar pago
                            </Button>

                            {/* small icon to open modal */}
                           
                                <Button
                                    size="sm"
                                    className="fs--2 me-2"
                                    onClick={onFacturarIngreso}
                                    variant="falcon-primary"
                                >Fact. Ingreso
                            </Button>

                        </Col>
                    </Row>
                </>
            )}
            {!p.bIsFacturado && p.idCatCuentaBancaria > 0 && orden.vClave != '99' && (
                <>
                    <hr></hr>
                    <p className="text-muted small">Este pago se factura junto con la orden.</p>
                </>
            )}
            <hr></hr>

        </div>
    );
};

PagoItem.propTypes = {
    pago: PropTypes.object.isRequired,
    idCatTipoUsuario: PropTypes.string.isRequired,
    onEdit: PropTypes.func.isRequired,
    onValidar: PropTypes.func.isRequired,
    onConciliar: PropTypes.func.isRequired,
    onFacturar: PropTypes.func.isRequired,
    onFacturarIngreso: PropTypes.func.isRequired,
    orden: PropTypes.object.isRequired
};

export default PagoItem;
